import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Banner (){
    return(
        <section className="main" id="main">
            <div className="content">
                <h2>Hello, I'm<br /><span>Matthieu Grauleau</span></h2>
                <div className="animated-text">
                <h3>Front End Developer</h3>
                </div>
                <a href="#work" className="button">See My Works</a>
                <div className="media-icons">
                <a href="https://www.linkedin.com/in/matthieu-grauleau-1577b147/" target="_blank" rel="noopener noreferrer" aria-label="Profil LinkedIn"><FontAwesomeIcon className="iconfontawesome" icon={faLinkedin} /></a>
                <a href="https://github.com/MatthieuGrauleau" target="_blank" rel="noopener noreferrer" aria-label="Profil GitHub"> <FontAwesomeIcon className="iconfontawesome" icon={faGithub} /></a>
                </div>
            </div>
        </section>
    );
    }
export default Banner